import {
	NeutralColor,
	PrimaryColor,
	SecondaryColor,
	SemanticColor,
} from "node-library/dist/colors";
import { SortOrder } from "node-library/dist/paginations";

interface IconProps {
	size?: number;
	strokeColor?: string;
	fillColor?: string;
	strokeWidth?: number;
}

function AlertIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || SemanticColor.ERROR;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.0277 16.223L14.6457 4.87804C14.1007 3.90804 13.1107 3.33008 11.9987 3.33008C10.8866 3.33008 9.89668 3.90906 9.35168 4.87804L2.96968 16.223C2.43468 17.1741 2.44468 18.305 2.99468 19.246C3.54468 20.1871 4.5257 20.75 5.61668 20.75H18.3807C19.4717 20.75 20.4517 20.188 21.0027 19.246C21.5537 18.304 21.5627 17.174 21.0277 16.223ZM19.7077 18.49C19.4287 18.9671 18.9327 19.2511 18.3806 19.2511H5.61664C5.0646 19.2511 4.56868 18.9671 4.2896 18.49C4.01062 18.0121 4.00562 17.4411 4.27663 16.959L10.6586 5.61402C10.9346 5.123 11.4357 4.83004 11.9986 4.83004C12.5616 4.83004 13.0626 5.123 13.3386 5.61402L19.7206 16.959C19.9916 17.4411 19.9867 18.013 19.7077 18.49ZM11.2487 13.001V9.00104C11.2487 8.58706 11.5847 8.25104 11.9987 8.25104C12.4127 8.25104 12.7487 8.58706 12.7487 9.00104V13.001C12.7487 13.415 12.4127 13.751 11.9987 13.751C11.5847 13.751 11.2487 13.415 11.2487 13.001ZM12.9987 16.001C12.9987 16.5531 12.5507 17.001 11.9987 17.001C11.4466 17.001 10.9987 16.5531 10.9987 16.001C10.9987 15.449 11.4466 15.001 11.9987 15.001C12.5507 15.001 12.9987 15.449 12.9987 16.001Z"
				fill={strokeColor}
			/>
		</svg>
	);
}

function EditIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || SemanticColor.INFO_MEDIUM;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.95396 19.38L5.95397 19.38L5.9801 19.3734L5.98012 19.3734L8.60809 18.7164C8.62428 18.7124 8.64043 18.7084 8.65654 18.7044C8.87531 18.65 9.08562 18.5978 9.27707 18.4894C9.46852 18.381 9.62153 18.2275 9.7807 18.0679C9.79242 18.0561 9.80418 18.0444 9.81598 18.0325L17.0101 10.8385L17.0101 10.8385L17.0369 10.8117C17.3472 10.5014 17.6215 10.2272 17.8128 9.97638C18.0202 9.70457 18.1858 9.39104 18.1858 9C18.1858 8.60896 18.0202 8.29543 17.8128 8.02361C17.6215 7.77285 17.3472 7.49863 17.0369 7.18835L17.01 7.16152L16.8385 6.98995L16.8117 6.96314C16.5014 6.6528 16.2272 6.37853 15.9764 6.1872C15.7046 5.97981 15.391 5.81421 15 5.81421C14.609 5.81421 14.2954 5.97981 14.0236 6.1872C13.7729 6.37853 13.4986 6.65278 13.1884 6.96311L13.1615 6.98995L5.96745 14.184C5.95565 14.1958 5.94386 14.2076 5.93211 14.2193C5.77249 14.3785 5.61904 14.5315 5.51064 14.7229C5.40225 14.9144 5.34999 15.1247 5.29562 15.3435C5.29162 15.3596 5.28761 15.3757 5.28356 15.3919L4.62003 18.046C4.61762 18.0557 4.61518 18.0654 4.61272 18.0752C4.57411 18.2293 4.53044 18.4035 4.51593 18.5518C4.49978 18.7169 4.50127 19.0162 4.74255 19.2574C4.98383 19.4987 5.28307 19.5002 5.44819 19.4841C5.59646 19.4696 5.77072 19.4259 5.92479 19.3873C5.9346 19.3848 5.94433 19.3824 5.95396 19.38Z"
				stroke={strokeColor}
				strokeWidth="1.2"
			/>
			<path d="M12.5 7.5L16.5 11.5" stroke={strokeColor} />
		</svg>
	);
}

function SmallEditIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 16;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	return (
		<svg
			width={iconSize}
			height={iconSize || 17}
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M9.98077 3.94098C10.3711 3.55043 11.0041 3.55016 11.3948 3.94039L12.4921 5.03642C12.8829 5.42681 12.8831 6.06013 12.4926 6.45084L6.161 12.786C6.02172 12.9253 5.84437 13.0204 5.65122 13.0593L2.7998 13.6339L3.37539 10.7858C3.41435 10.593 3.50927 10.416 3.64828 10.2769L9.98077 3.94098Z"
				fill={strokeColor}
				stroke={strokeColor}
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function InfoIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10 1.25C8.26942 1.25 6.57769 1.76318 5.13876 2.72464C3.69983 3.6861 2.57832 5.05267 1.91606 6.65152C1.25379 8.25037 1.08051 10.0097 1.41813 11.707C1.75575 13.4044 2.58911 14.9635 3.81282 16.1872C5.03653 17.4109 6.59563 18.2442 8.29296 18.5819C9.9903 18.9195 11.7496 18.7462 13.3485 18.0839C14.9473 17.4217 16.3139 16.3002 17.2754 14.8612C18.2368 13.4223 18.75 11.7306 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25ZM10 17.5C8.51664 17.5 7.0666 17.0601 5.83323 16.236C4.59986 15.4119 3.63856 14.2406 3.07091 12.8701C2.50325 11.4997 2.35473 9.99168 2.64411 8.53682C2.9335 7.08197 3.64781 5.74559 4.6967 4.6967C5.7456 3.64781 7.08197 2.9335 8.53683 2.64411C9.99168 2.35472 11.4997 2.50325 12.8701 3.0709C14.2406 3.63856 15.4119 4.59985 16.236 5.83322C17.0601 7.06659 17.5 8.51664 17.5 10C17.5 11.9891 16.7098 13.8968 15.3033 15.3033C13.8968 16.7098 11.9891 17.5 10 17.5Z"
				fill={strokeColor}
			/>
			<path
				d="M9.375 5H10.625V11.875H9.375V5ZM10 13.75C9.81458 13.75 9.63332 13.805 9.47915 13.908C9.32498 14.011 9.20482 14.1574 9.13386 14.3287C9.06291 14.5 9.04434 14.6885 9.08051 14.8704C9.11669 15.0523 9.20598 15.2193 9.33709 15.3504C9.4682 15.4815 9.63525 15.5708 9.8171 15.607C9.99896 15.6432 10.1875 15.6246 10.3588 15.5536C10.5301 15.4827 10.6765 15.3625 10.7795 15.2083C10.8825 15.0542 10.9375 14.8729 10.9375 14.6875C10.9375 14.4389 10.8387 14.2004 10.6629 14.0246C10.4871 13.8488 10.2486 13.75 10 13.75Z"
				fill={strokeColor}
			/>
		</svg>
	);
}
function SaveIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13.8889 18H6.11111M13.8889 18H14.5134C15.383 18 15.8178 18 16.1499 17.8183C16.4431 17.6583 16.6811 17.4033 16.8304 17.09C17 16.7342 17 16.2675 17 15.3358V8.18333C17 7.80833 17 7.62083 16.9627 7.4425C16.9295 7.28341 16.8747 7.13039 16.8001 6.98833C16.7177 6.83 16.601 6.6925 16.3723 6.42L14.2296 3.86833C13.9643 3.55333 13.8298 3.39333 13.6688 3.27833C13.5236 3.17511 13.3632 3.09877 13.1943 3.0525C13.0046 3 12.8 3 12.3917 3H5.48889C4.61778 3 4.18222 3 3.84933 3.18167C3.55665 3.34145 3.31869 3.59641 3.16956 3.91C3 4.26667 3 4.73333 3 5.66667V15.3333C3 16.2667 3 16.7333 3.16956 17.0892C3.31889 17.4033 3.55611 17.6583 3.84933 17.8183C4.18144 18 4.617 18 5.48656 18H6.11111M13.8889 18V14.8308C13.8889 13.8992 13.8889 13.4325 13.7193 13.0767C13.57 12.7629 13.3318 12.508 13.0388 12.3483C12.7067 12.1667 12.2711 12.1667 11.4 12.1667H8.6C7.72889 12.1667 7.29333 12.1667 6.96044 12.3483C6.66776 12.5081 6.4298 12.7631 6.28067 13.0767C6.11111 13.4333 6.11111 13.9 6.11111 14.8333V18M12.3333 6.33333H7.66667"
				stroke={strokeColor}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function CopyIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M11.6663 5.83301V5.33301C11.6663 4.22844 10.7709 3.33301 9.66634 3.33301H5.33301C4.22844 3.33301 3.33301 4.22844 3.33301 5.33301V9.66634C3.33301 10.7709 4.22844 11.6663 5.33301 11.6663H5.83301"
				stroke={strokeColor}
				strokeLinecap="round"
			/>
			<rect
				x="8.33301"
				y="8.33301"
				width="8.33333"
				height="8.33333"
				rx="2"
				stroke={strokeColor}
			/>
		</svg>
	);
}

function DeleteIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.33301 4.5C3.05687 4.5 2.83301 4.72386 2.83301 5C2.83301 5.27614 3.05687 5.5 3.33301 5.5V4.5ZM16.6663 5.5C16.9425 5.5 17.1663 5.27614 17.1663 5C17.1663 4.72386 16.9425 4.5 16.6663 4.5V5.5ZM4.73652 5V4.5H4.23652V5H4.73652ZM15.2628 5H15.7628V4.5H15.2628V5ZM5.31126 17.3638L5.05243 17.7915L5.31126 17.3638ZM4.85125 16.8175L4.39176 17.0146L4.85125 16.8175ZM15.1481 16.8175L15.6076 17.0146L15.1481 16.8175ZM14.6881 17.3638L14.9469 17.7915L14.6881 17.3638ZM3.33301 5.5H16.6663V4.5H3.33301V5.5ZM4.73652 5.5H15.2628V4.5H4.73652V5.5ZM14.7628 5V15.5H15.7628V5H14.7628ZM13.5786 17H6.42073V18H13.5786V17ZM5.23652 15.5V5H4.23652V15.5H5.23652ZM6.42073 17C6.11619 17 5.92345 16.9995 5.77765 16.9853C5.64077 16.972 5.59363 16.9502 5.5701 16.936L5.05243 17.7915C5.25406 17.9135 5.4669 17.9599 5.68108 17.9806C5.88633 18.0005 6.13574 18 6.42073 18V17ZM4.23652 15.5C4.23652 15.8431 4.23624 16.1257 4.25204 16.3553C4.26809 16.5887 4.30256 16.8068 4.39176 17.0146L5.31074 16.6203C5.2852 16.5608 5.26231 16.4702 5.24968 16.2867C5.23679 16.0994 5.23652 15.857 5.23652 15.5H4.23652ZM5.5701 16.936C5.47076 16.8759 5.37504 16.7702 5.31074 16.6203L4.39176 17.0146C4.52929 17.3352 4.75564 17.612 5.05243 17.7915L5.5701 16.936ZM14.7628 15.5C14.7628 15.857 14.7626 16.0994 14.7497 16.2867C14.737 16.4702 14.7141 16.5608 14.6886 16.6203L15.6076 17.0146C15.6968 16.8068 15.7313 16.5887 15.7473 16.3553C15.7631 16.1257 15.7628 15.8431 15.7628 15.5H14.7628ZM13.5786 18C13.8636 18 14.113 18.0005 14.3183 17.9806C14.5324 17.9599 14.7453 17.9135 14.9469 17.7915L14.4292 16.936C14.4057 16.9502 14.3586 16.972 14.2217 16.9853C14.0759 16.9995 13.8832 17 13.5786 17V18ZM14.6886 16.6203C14.6243 16.7702 14.5286 16.8759 14.4292 16.936L14.9469 17.7915C15.2437 17.612 15.4701 17.3352 15.6076 17.0146L14.6886 16.6203Z"
				fill={strokeColor}
			/>
			<path d="M8.33301 7.5V15" stroke={strokeColor} strokeLinecap="round" />
			<path d="M11.666 7.5V15" stroke={strokeColor} strokeLinecap="round" />
			<path
				d="M8.33301 3.33301H11.6663"
				stroke={strokeColor}
				strokeLinecap="round"
			/>
		</svg>
	);
}

function SmallDeleteIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 17;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 17 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M6.26237 14.4341H11.5957C12.3321 14.4341 12.929 13.802 12.929 13.0223V5.25761C12.929 4.86776 12.6306 4.55173 12.2624 4.55173H5.5957C5.22751 4.55173 4.92904 4.86776 4.92904 5.25761V13.0223C4.92904 13.802 5.52599 14.4341 6.26237 14.4341Z"
				fill={strokeColor}
			/>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M3.5957 4.05173C3.31956 4.05173 3.0957 4.27559 3.0957 4.55173C3.0957 4.82787 3.31956 5.05173 3.5957 5.05173L3.5957 4.05173ZM14.2624 5.05173C14.5385 5.05173 14.7624 4.82787 14.7624 4.55173C14.7624 4.27559 14.5385 4.05173 14.2624 4.05173V5.05173ZM11.5957 13.9341H6.26237V14.9341H11.5957V13.9341ZM12.429 13.0223C12.429 13.5532 12.0294 13.9341 11.5957 13.9341V14.9341C12.6348 14.9341 13.429 14.0508 13.429 13.0223H12.429ZM12.429 5.25761V13.0223H13.429V5.25761H12.429ZM5.42904 13.0223V5.25761H4.42904V13.0223H5.42904ZM6.26237 13.9341C5.82867 13.9341 5.42904 13.5532 5.42904 13.0223H4.42904C4.42904 14.0508 5.22331 14.9341 6.26237 14.9341V13.9341ZM12.2624 4.05173H5.5957V5.05173H12.2624V4.05173ZM5.42904 5.25761C5.42904 5.11659 5.5302 5.05173 5.5957 5.05173V4.05173C4.92483 4.05173 4.42904 4.61893 4.42904 5.25761H5.42904ZM13.429 5.25761C13.429 4.61893 12.9332 4.05173 12.2624 4.05173V5.05173C12.3279 5.05173 12.429 5.1166 12.429 5.25761H13.429ZM3.5957 5.05173L14.2624 5.05173V4.05173L3.5957 4.05173L3.5957 5.05173ZM7.5957 2.93408H10.2624V1.93408H7.5957V2.93408ZM10.429 3.13996V4.10075H11.429V3.13996H10.429ZM7.42904 4.10075V3.13996H6.42904V4.10075H7.42904ZM10.2624 2.93408C10.3279 2.93408 10.429 2.99895 10.429 3.13996H11.429C11.429 2.50129 10.9332 1.93408 10.2624 1.93408V2.93408ZM7.5957 1.93408C6.92483 1.93408 6.42904 2.50128 6.42904 3.13996H7.42904C7.42904 2.99895 7.5302 2.93408 7.5957 2.93408V1.93408Z"
				fill={strokeColor}
			/>
		</svg>
	);
}

function COAIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || "#222222";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.08398 10.416L12.9173 10.416"
				stroke={strokeColor}
				strokeLinecap="round"
			/>
			<path
				d="M7.08398 12.916L10.4173 12.916"
				stroke={strokeColor}
				strokeLinecap="round"
			/>
			<path
				d="M4.58398 5.31602C4.58398 4.47594 4.58398 4.0559 4.74747 3.73503C4.89128 3.45279 5.12076 3.22332 5.403 3.07951C5.72387 2.91602 6.14391 2.91602 6.98398 2.91602H10.2565C10.6234 2.91602 10.8069 2.91602 10.9795 2.95746C11.1326 2.99421 11.2789 3.05481 11.4131 3.13706C11.5645 3.22982 11.6942 3.35953 11.9536 3.61896L14.7144 6.37974C14.9738 6.63917 15.1035 6.76888 15.1963 6.92025C15.2785 7.05446 15.3391 7.20078 15.3759 7.35383C15.4173 7.52647 15.4173 7.70991 15.4173 8.0768V14.6827C15.4173 15.5228 15.4173 15.9428 15.2538 16.2637C15.11 16.5459 14.8805 16.7754 14.5983 16.9192C14.2774 17.0827 13.8574 17.0827 13.0173 17.0827H6.98398C6.14391 17.0827 5.72387 17.0827 5.403 16.9192C5.12076 16.7754 4.89128 16.5459 4.74747 16.2637C4.58398 15.9428 4.58398 15.5228 4.58398 14.6827V5.31602Z"
				stroke={strokeColor}
			/>
			<path
				d="M10.416 2.91602V5.51602C10.416 6.35609 10.416 6.77613 10.5795 7.097C10.7233 7.37924 10.9528 7.60872 11.235 7.75253C11.5559 7.91602 11.9759 7.91602 12.816 7.91602H15.416"
				stroke={strokeColor}
			/>
		</svg>
	);
}
function ReportsIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.9997 9.16667V4.5C14.9997 3.39543 14.1042 2.5 12.9997 2.5H5.33301C4.22844 2.5 3.33301 3.39543 3.33301 4.5V15.5C3.33301 16.6046 4.22844 17.5 5.33301 17.5H9.16634"
				stroke={strokeColor}
				strokeLinecap="round"
			/>
			<circle
				cx="13.7493"
				cy="14.5833"
				r="2.08333"
				stroke={strokeColor}
				strokeLinecap="round"
			/>
			<path
				d="M16.666 17.5L15.416 16.25"
				stroke={strokeColor}
				strokeLinecap="round"
			/>
			<path
				d="M12.499 5.83398L9.99902 8.33399L8.33236 6.66732L5.83236 9.16732"
				stroke={strokeColor}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M6 11H12.5" stroke={strokeColor} strokeLinecap="round" />
		</svg>
	);
}

function ViewResultIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || "#121212";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.0007 9.16667V4.5C15.0007 3.39543 14.1052 2.5 13.0007 2.5H5.33399C4.22942 2.5 3.33398 3.39543 3.33398 4.5V15.5C3.33398 16.6046 4.22941 17.5 5.33398 17.5H9.16732"
				stroke={strokeColor}
				strokeLinecap="round"
			/>
			<circle
				cx="13.7513"
				cy="14.5833"
				r="2.08333"
				stroke={strokeColor}
				strokeLinecap="round"
			/>
			<path
				d="M16.668 17.5L15.418 16.25"
				stroke={strokeColor}
				strokeLinecap="round"
			/>
			<path
				d="M12.5 5.83398L10 8.33399L8.33333 6.66732L5.83333 9.16732"
				stroke={strokeColor}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M6.00195 11H12.502" stroke={strokeColor} strokeLinecap="round" />
		</svg>
	);
}

interface SortIconProps extends IconProps {
	sortOrder: SortOrder;
	notInUse?: boolean;
}

function SortArrowIcon(props: SortIconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	const unselectedColor = NeutralColor.NEUTRAL_GREY_300;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.66699 4.00065L5.33366 1.33398M5.33366 1.33398L8.00032 4.00065M5.33366 1.33398L5.33366 11.334"
				stroke={
					props.notInUse || props.sortOrder !== SortOrder.DESC
						? unselectedColor
						: strokeColor
				}
				strokeLinecap="round"
			/>
			<path
				d="M8 11.9993L10.6667 14.666M10.6667 14.666L13.3333 11.9993M10.6667 14.666L10.6667 4.66602"
				stroke={
					props.notInUse || props.sortOrder !== SortOrder.ASC
						? unselectedColor
						: strokeColor
				}
				strokeLinecap="round"
			/>
		</svg>
	);
}

function DownloadIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7 9L12 14M12 14L17 9M12 14L12 5"
				stroke={strokeColor}
				strokeWidth="1.8"
				strokeLinecap="round"
			/>
			<path
				d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16"
				stroke={strokeColor}
				strokeWidth="1.8"
				strokeLinecap="round"
			/>
		</svg>
	);
}

function UserIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	const fillColor = props.fillColor;
	const strokeWidth = props.strokeWidth || 2;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				cx="12"
				cy="8"
				r="3"
				stroke={strokeColor}
				fill={fillColor}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
			/>
			<path
				d="M5.33788 17.3206C5.99897 14.5269 8.77173 13 11.6426 13H12.3574C15.2283 13 18.001 14.5269 18.6621 17.3206C18.79 17.8611 18.8917 18.4268 18.9489 19.0016C19.0036 19.5512 18.5523 20 18 20H6C5.44772 20 4.99642 19.5512 5.0511 19.0016C5.1083 18.4268 5.20997 17.8611 5.33788 17.3206Z"
				stroke={strokeColor}
				fill={fillColor}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
			/>
		</svg>
	);
}

function UserGroupIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	const fillColor = props.fillColor;
	const strokeWidth = props.strokeWidth || 2;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				cx="16.3333"
				cy="8.44466"
				r="3.08333"
				fill="#11B88E"
				stroke="#11B88E"
				strokeWidth="0.5"
				strokeLinecap="round"
			/>
			<circle
				cx="8.33333"
				cy="8.44466"
				r="3.08333"
				fill="#11B88E"
				stroke="#11B88E"
				strokeWidth="0.5"
				strokeLinecap="round"
			/>
			<path
				d="M10.2227 16.8364C10.7686 14.2431 13.3498 12.834 16 12.834C18.6502 12.834 21.2314 14.2431 21.7773 16.8364C21.8459 17.1623 21.9022 17.497 21.941 17.8361C22.0038 18.3848 21.5523 18.834 21 18.834H11C10.4477 18.834 9.99619 18.3848 10.059 17.8361C10.0978 17.497 10.1541 17.1623 10.2227 16.8364Z"
				fill="#11B88E"
				stroke="#11B88E"
				strokeWidth="0.5"
				strokeLinecap="round"
			/>
			<path
				d="M2.22272 16.8364C2.76864 14.2431 5.34982 12.834 8 12.834C10.6502 12.834 13.2314 14.2431 13.7773 16.8364C13.8459 17.1623 13.9022 17.497 13.941 17.8361C14.0038 18.3848 13.5523 18.834 13 18.834H3C2.44772 18.834 1.99619 18.3848 2.05902 17.8361C2.09784 17.497 2.15412 17.1623 2.22272 16.8364Z"
				fill="#11B88E"
				stroke="#11B88E"
				strokeWidth="0.5"
				strokeLinecap="round"
			/>
			<circle
				cx="12.0001"
				cy="8.44444"
				r="4.19444"
				fill="#11B88E"
				stroke="#D1FAE8"
				strokeWidth="0.5"
				strokeLinecap="round"
			/>
			<path
				d="M4.69864 17.9708C5.55064 14.8335 8.5692 12.8887 11.8201 12.8887H12.1798C15.4307 12.8887 18.4493 14.8335 19.3012 17.9708C19.464 18.5701 19.5994 19.1525 19.6838 19.6721C19.7723 20.2172 19.33 20.6665 18.7777 20.6665H5.22217C4.66988 20.6665 4.22761 20.2172 4.31611 19.6721C4.40046 19.1525 4.53589 18.5701 4.69864 17.9708Z"
				fill="#11B88E"
				stroke="#D1FAE8"
				strokeWidth="0.5"
				strokeLinecap="round"
			/>
		</svg>
	);
}

function BillingIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3 9V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V9M3 9V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V9M3 9H21M7 13H12"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

//sidebar
function HomeIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || SecondaryColor.SECONDARY_800;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5 12.7595C5 11.4018 5 10.7229 5.27446 10.1262C5.54892 9.52943 6.06437 9.08763 7.09525 8.20401L8.09525 7.34687C9.95857 5.74974 10.8902 4.95117 12 4.95117C13.1098 4.95117 14.0414 5.74974 15.9047 7.34687L16.9047 8.20401C17.9356 9.08763 18.4511 9.52943 18.7255 10.1262C19 10.7229 19 11.4018 19 12.7595V16.9999C19 18.8856 19 19.8284 18.4142 20.4142C17.8284 20.9999 16.8856 20.9999 15 20.9999H9C7.11438 20.9999 6.17157 20.9999 5.58579 20.4142C5 19.8284 5 18.8856 5 16.9999V12.7595Z"
				stroke={strokeColor}
			/>
			<path
				d="M14.5 21V16C14.5 15.4477 14.0523 15 13.5 15H10.5C9.94772 15 9.5 15.4477 9.5 16V21"
				stroke={strokeColor}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function OrderIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || SecondaryColor.SECONDARY_800;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.5 5C16.9045 5 17.6067 5 18.1111 5.33706C18.3295 5.48298 18.517 5.67048 18.6629 5.88886C19 6.39331 19 7.09554 19 8.5V18C19 19.8856 19 20.8284 18.4142 21.4142C17.8284 22 16.8856 22 15 22H9C7.11438 22 6.17157 22 5.58579 21.4142C5 20.8284 5 19.8856 5 18V8.5C5 7.09554 5 6.39331 5.33706 5.88886C5.48298 5.67048 5.67048 5.48298 5.88886 5.33706C6.39331 5 7.09554 5 8.5 5"
				stroke={strokeColor}
				strokeWidth="2"
			/>
			<path
				d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5C15 6.10457 14.1046 7 13 7H11C9.89543 7 9 6.10457 9 5Z"
				stroke={strokeColor}
				strokeWidth="2"
			/>
			<path
				d="M9 12L15 12"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M9 16L13 16"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
}

function CompanyIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	const fillColor = props.fillColor || NeutralColor.NEUTRAL_GREY_900;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4 6.93945L13.9794 4.2832L15.0828 5.3457V10.6582L20.6 12.252V21.2832H15.0828H4V6.93945Z"
				fill={fillColor}
			/>
			<path
				d="M20.9676 22.2832H3.23176C2.89619 22.2783 2.6207 22.0112 2.60068 21.6709C2.58146 21.3306 2.82411 21.0326 3.15727 20.9888V7.83417C3.16047 6.84507 3.80516 5.97616 4.74137 5.69914L12.7187 3.37008C13.3802 3.17681 14.0929 3.30999 14.6431 3.72983C15.1933 4.14968 15.5168 4.80745 15.516 5.50504V9.92271C15.5681 9.93083 15.6194 9.94219 15.6698 9.95681L20.2291 11.2878C20.7096 11.4291 21.0403 11.8749 21.042 12.3825V20.9888C21.3751 21.0326 21.6178 21.3306 21.5985 21.6709C21.5785 22.0112 21.3032 22.2783 20.9676 22.2832ZM15.517 20.9839H19.7607V12.5027L15.517 11.2643V20.9839ZM12.0228 20.9839H14.2348V5.50509C14.2348 5.21519 14.1002 4.94234 13.872 4.76774C13.6438 4.59396 13.3483 4.53873 13.0736 4.61832L5.09627 6.94738C4.70786 7.0627 4.44036 7.42408 4.43877 7.83417V20.9841H6.65161L6.65241 16.0037C6.65241 15.8316 6.71969 15.6667 6.83982 15.5449C6.95995 15.4231 7.12252 15.3541 7.2931 15.3541H11.3813C11.5511 15.3541 11.7145 15.4231 11.8346 15.5449C11.9548 15.6667 12.022 15.8316 12.022 16.0037L12.0228 20.9839ZM7.93455 20.9839H10.7414L10.7406 16.6532H7.93375L7.93455 20.9839Z"
				fill={strokeColor}
			/>
		</svg>
	);
}

function LockIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	const fillColor = props.fillColor || NeutralColor.NEUTRAL_GREY_900;

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.59766 15.2832C4.59766 12.4548 4.59766 11.0406 5.47634 10.1619C6.35502 9.2832 7.76923 9.2832 10.5977 9.2832H14.5977C17.4261 9.2832 18.8403 9.2832 19.719 10.1619C20.5977 11.0406 20.5977 12.4548 20.5977 15.2832C20.5977 18.1116 20.5977 19.5258 19.719 20.4045C18.8403 21.2832 17.4261 21.2832 14.5977 21.2832H10.5977C7.76923 21.2832 6.35502 21.2832 5.47634 20.4045C4.59766 19.5258 4.59766 18.1116 4.59766 15.2832Z"
				fill={fillColor}
				stroke={strokeColor}
				strokeWidth="1.5"
			/>
			<path
				d="M16.5977 9.00959V7.19141C16.5977 4.98227 14.8068 3.19141 12.5977 3.19141V3.19141C10.3885 3.19141 8.59766 4.98227 8.59766 7.19141V9.00959"
				stroke={strokeColor}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<circle cx="12.5977" cy="15.2832" r="1.5" fill="white" />
		</svg>
	);
}

function InvoiceIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_100;
	const fillColor = props.fillColor || PrimaryColor.PRIMARY_500;

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.42676 2.49089L3.02441 1.42578H17.4033L18.4684 3.02344L19.001 6.21875H15.2731V17.4023L14.7406 18.4675L11.5452 16.8698L7.81738 19L4.62207 16.8698L1.42676 18.4675V2.49089Z"
				fill={fillColor}
			/>
			<path
				d="M17.1181 1C16.1224 1 15.3145 3.40313 15.3145 6.36813H17.1181C17.9878 6.36813 18.4217 6.36813 18.691 6.06841C18.9594 5.76779 18.9129 5.37234 18.8198 4.58233C18.5711 2.49413 17.9037 1 17.1181 1Z"
				fill={fillColor}
				stroke={strokeColor}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.315 6.41644V15.893C15.315 17.2448 15.315 17.9212 14.9017 18.1878C14.2262 18.6227 13.1821 17.7101 12.6569 17.379C12.223 17.1053 12.0064 16.9693 11.7658 16.9612C11.5054 16.9523 11.2844 17.0838 10.8156 17.379L9.10587 18.4571C8.64421 18.7479 8.41428 18.8938 8.1575 18.8938C7.90073 18.8938 7.6699 18.7479 7.20913 18.4571L5.50028 17.379C5.06546 17.1053 4.84895 16.9693 4.60828 16.9612C4.34792 16.9523 4.12693 17.0838 3.65812 17.379C3.13294 17.7101 2.08883 18.6227 1.41245 18.1878C1 17.9212 1 17.2457 1 15.893V6.41644C1 3.863 1 2.58718 1.78643 1.79359C2.57197 1 3.83795 1 6.36813 1H17.1044"
				fill={fillColor}
			/>
			<path
				d="M15.315 6.41644V15.893C15.315 17.2448 15.315 17.9212 14.9017 18.1878C14.2262 18.6227 13.1821 17.7101 12.6569 17.379C12.223 17.1053 12.0064 16.9693 11.7658 16.9612C11.5054 16.9523 11.2844 17.0838 10.8156 17.379L9.10587 18.4571C8.64421 18.7479 8.41428 18.8938 8.1575 18.8938C7.90073 18.8938 7.6699 18.7479 7.20913 18.4571L5.50028 17.379C5.06546 17.1053 4.84895 16.9693 4.60828 16.9612C4.34792 16.9523 4.12693 17.0838 3.65812 17.379C3.13294 17.7101 2.08883 18.6227 1.41245 18.1878C1 17.9212 1 17.2457 1 15.893V6.41644C1 3.863 1 2.58718 1.78643 1.79359C2.57197 1 3.83795 1 6.36813 1H17.1044C15.7693 2.37032 15.5039 3.24215 15.315 6.41644Z"
				stroke={strokeColor}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.15754 6.3693C7.16891 6.3693 6.36816 6.97053 6.36816 7.71133C6.36816 8.45213 7.16891 9.05336 8.15754 9.05336C9.14617 9.05336 9.94691 9.65459 9.94691 10.3954C9.94691 11.1362 9.14617 11.7374 8.15754 11.7374M8.15754 6.3693C8.93592 6.3693 9.59978 6.74238 9.84492 7.26398L8.15754 6.3693ZM8.15754 6.3693V5.47461V6.3693ZM8.15754 11.7374C7.37916 11.7374 6.7153 11.3643 6.47016 10.8427L8.15754 11.7374ZM8.15754 11.7374V12.6321V11.7374Z"
				fill={fillColor}
			/>
			<path
				d="M8.15754 6.3693C7.16891 6.3693 6.36816 6.97053 6.36816 7.71133C6.36816 8.45213 7.16891 9.05336 8.15754 9.05336C9.14617 9.05336 9.94691 9.65459 9.94691 10.3954C9.94691 11.1362 9.14617 11.7374 8.15754 11.7374M8.15754 6.3693C8.93592 6.3693 9.59978 6.74238 9.84492 7.26398M8.15754 6.3693V5.47461M8.15754 11.7374C7.37916 11.7374 6.7153 11.3643 6.47016 10.8427M8.15754 11.7374V12.6321"
				stroke={strokeColor}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function LicenseIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const fillColor = props.fillColor || NeutralColor.NEUTRAL_GREY_900;

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 9C2 7.34314 3.34315 6 5 6H19C20.6569 6 22 7.34315 22 9V16.3333C22 17.9902 20.6569 19.3333 19 19.3333H5C3.34315 19.3333 2 17.9902 2 16.3333V9ZM8.34449 12.6208C9.10048 12.6208 9.68871 12.0204 9.68871 11.31C9.68871 10.5996 9.10048 9.99926 8.34449 9.99926C7.58851 9.99926 7.00028 10.5996 7.00028 11.31C7.00028 12.0204 7.58851 12.6208 8.34449 12.6208ZM8.34449 13.6208C9.63917 13.6208 10.6887 12.5862 10.6887 11.31C10.6887 10.0338 9.63917 8.99926 8.34449 8.99926C7.04982 8.99926 6.00028 10.0338 6.00028 11.31C6.00028 12.5862 7.04982 13.6208 8.34449 13.6208ZM13.5012 9.42374C13.2251 9.42374 13.0012 9.64759 13.0012 9.92374C13.0012 10.1999 13.2251 10.4237 13.5012 10.4237H17.8771C18.1532 10.4237 18.3771 10.1999 18.3771 9.92374C18.3771 9.64759 18.1532 9.42374 17.8771 9.42374H13.5012ZM13.0012 13.006C13.0012 12.7298 13.2251 12.506 13.5012 12.506H17.8771C18.1532 12.506 18.3771 12.7298 18.3771 13.006C18.3771 13.2821 18.1532 13.506 17.8771 13.506H13.5012C13.2251 13.506 13.0012 13.2821 13.0012 13.006ZM6.62528 15.5844C6.34914 15.5844 6.12528 15.8083 6.12528 16.0844C6.12528 16.3606 6.34914 16.5844 6.62528 16.5844H17.8775C18.1537 16.5844 18.3775 16.3606 18.3775 16.0844C18.3775 15.8083 18.1537 15.5844 17.8775 15.5844H6.62528Z"
				fill={fillColor}
			/>
		</svg>
	);
}

function FileIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const fillColor = props.fillColor || NeutralColor.NEUTRAL_GREY_900;

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5 5C5 3.89543 5.89543 3 7 3H11.75C11.8881 3 12 3.11193 12 3.25V8C12 9.10457 12.8954 10 14 10H18.75C18.8881 10 19 10.1119 19 10.25V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V5Z"
				fill={fillColor}
			/>
			<path
				d="M13 8V3.60355C13 3.38083 13.2693 3.26929 13.4268 3.42678L18.5732 8.57322C18.7307 8.73071 18.6192 9 18.3964 9H14C13.4477 9 13 8.55228 13 8Z"
				fill={fillColor}
			/>
			<path d="M8.5 13.5L14.5 13.5" stroke="white" strokeLinecap="round" />
			<path d="M8.5 16.5L13.5 16.5" stroke="white" strokeLinecap="round" />
		</svg>
	);
}

function EmailIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_500;
	const fillColor = props.fillColor || undefined;

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="3.33301"
				y="5"
				width="13.3333"
				height="10"
				rx="2"
				stroke={fillColor ? fillColor : strokeColor}
				fill={fillColor}
			/>
			<path
				d="M3.33301 7.5L9.10525 10.3861C9.6683 10.6676 10.331 10.6676 10.8941 10.3861L16.6663 7.5"
				stroke={strokeColor}
			/>
		</svg>
	);
}
function PhoneIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_500;
	const fillColor = props.fillColor || "transparent";

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13.8182 11.9293L15.5343 13.6454C15.7915 13.9026 15.7915 14.3196 15.5343 14.5768C14.1439 15.9672 11.9426 16.1237 10.3696 14.9438L9.56953 14.3438C8.08626 13.2314 6.76864 11.9137 5.65619 10.4305L5.05617 9.63045C3.87635 8.05735 4.03279 5.8561 5.42322 4.46567C5.6804 4.20849 6.09738 4.20849 6.35456 4.46567L8.07067 6.18178C8.46119 6.57231 8.46119 7.20547 8.07067 7.596L7.52959 8.13707C7.41239 8.25428 7.38333 8.43333 7.45746 8.58158C8.31449 10.2957 9.70435 11.6855 11.4184 12.5425C11.5667 12.6167 11.7457 12.5876 11.8629 12.4704L12.404 11.9293C12.7945 11.5388 13.4277 11.5388 13.8182 11.9293Z"
				stroke={strokeColor}
				fill={fillColor}
			/>
		</svg>
	);
}

function FolderIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 32;

	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_600;
	const fillColor = props.fillColor || PrimaryColor.PRIMARY_800;

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 33 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.87305 10.668C4.87305 8.78235 4.87305 7.83954 5.45883 7.25376C5.45883 7.25376 5.45883 7.25376 5.45883 7.25376C6.04462 6.66797 6.98743 6.66797 8.87305 6.66797H12.5495C13.367 6.66797 13.7758 6.66797 14.1433 6.82021C14.5109 6.97245 14.7999 7.26148 15.378 7.83954L18.2064 10.668V14.668H4.87305V10.668Z"
				fill={strokeColor}
			/>
			<path
				d="M4.87305 13.868C4.87305 12.7479 4.87305 12.1878 5.09103 11.76C5.28278 11.3837 5.58874 11.0777 5.96507 10.886C6.39289 10.668 6.95294 10.668 8.07305 10.668H25.673C26.7932 10.668 27.3532 10.668 27.781 10.886C28.1574 11.0777 28.4633 11.3837 28.6551 11.76C28.873 12.1878 28.873 12.7479 28.873 13.868V22.1346C28.873 23.2547 28.873 23.8148 28.6551 24.2426C28.4633 24.6189 28.1574 24.9249 27.781 25.1166C27.3532 25.3346 26.7932 25.3346 25.673 25.3346H8.07305C6.95294 25.3346 6.39289 25.3346 5.96507 25.1166C5.58874 24.9249 5.28278 24.6189 5.09103 24.2426C4.87305 23.8148 4.87305 23.2547 4.87305 22.1346V13.868Z"
				fill={fillColor}
			/>
		</svg>
	);
}

function UploadIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 32;

	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;

	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 33 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.33301 13.3346L15.9993 6.66797M15.9993 6.66797L22.6656 13.3346M15.9993 6.66797L15.9993 18.668"
				stroke={strokeColor}
				strokeWidth="2.5"
				strokeLinecap="round"
			/>
			<path
				d="M6.66602 21.332L6.66602 22.6654C6.66602 24.1381 7.85986 25.332 9.33253 25.332L22.6651 25.332C24.1378 25.332 25.3316 24.1381 25.3316 22.6654V21.332"
				stroke={strokeColor}
				strokeWidth="2.5"
				strokeLinecap="round"
			/>
		</svg>
	);
}

function CommentIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	const fillColor = props.fillColor;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.32698 6.63803L4.21799 7.09202L4.21799 7.09202L3.32698 6.63803ZM3.7682 21.9425L4.4753 22.6496L4.4753 22.6496L3.7682 21.9425ZM19.0725 17.9559L19.5265 18.8469L19.5265 18.8469L19.0725 17.9559ZM20.3835 16.6448L19.4925 16.1909L19.4925 16.1909L20.3835 16.6448ZM20.3835 6.63803L19.4925 7.09202L19.4925 7.09202L20.3835 6.63803ZM19.0725 5.32698L19.5265 4.43597L19.5265 4.43597L19.0725 5.32698ZM4.63803 5.32698L5.09202 6.21799L5.09202 6.21799L4.63803 5.32698ZM7.42758 18.2831L8.13469 18.9902L7.42758 18.2831ZM4 9.8C4 8.94342 4.00078 8.36113 4.03755 7.91104C4.07337 7.47262 4.1383 7.24842 4.21799 7.09202L2.43597 6.18404C2.18868 6.66937 2.09012 7.18608 2.04419 7.74817C1.99922 8.2986 2 8.97642 2 9.8H4ZM4 12.7485V9.8H2V12.7485H4ZM2 12.7485V18.2829H4V12.7485H2ZM2 18.2829V18.2831H4V18.2829H2ZM2 18.2831V21.6243H4V18.2831H2ZM2 21.6243C2 22.9161 3.56185 23.5631 4.4753 22.6496L3.06109 21.2354C3.40757 20.8889 4 21.1343 4 21.6243H2ZM4.4753 22.6496L8.13469 18.9902L6.72048 17.576L3.06109 21.2354L4.4753 22.6496ZM15.9105 17.2829H7.42777V19.2829H15.9105V17.2829ZM18.6185 17.0649C18.4621 17.1446 18.2379 17.2095 17.7995 17.2453C17.3494 17.2821 16.7671 17.2829 15.9105 17.2829V19.2829C16.7341 19.2829 17.4119 19.2837 17.9623 19.2387C18.5244 19.1928 19.0411 19.0942 19.5265 18.8469L18.6185 17.0649ZM19.4925 16.1909C19.3008 16.5672 18.9948 16.8731 18.6185 17.0649L19.5265 18.8469C20.2791 18.4634 20.891 17.8515 21.2745 17.0988L19.4925 16.1909ZM19.7105 13.4829C19.7105 14.3395 19.7097 14.9217 19.6729 15.3718C19.6371 15.8103 19.5722 16.0345 19.4925 16.1909L21.2745 17.0988C21.5218 16.6135 21.6204 16.0968 21.6663 15.5347C21.7113 14.9843 21.7105 14.3064 21.7105 13.4829H19.7105ZM19.7105 9.8V13.4829H21.7105V9.8H19.7105ZM19.4925 7.09202C19.5722 7.24842 19.6371 7.47262 19.6729 7.91104C19.7097 8.36113 19.7105 8.94342 19.7105 9.8H21.7105C21.7105 8.97642 21.7113 8.2986 21.6663 7.74817C21.6204 7.18608 21.5218 6.66937 21.2745 6.18404L19.4925 7.09202ZM18.6185 6.21799C18.9948 6.40973 19.3008 6.7157 19.4925 7.09202L21.2745 6.18404C20.891 5.43139 20.2791 4.81947 19.5265 4.43597L18.6185 6.21799ZM15.9105 6C16.7671 6 17.3494 6.00078 17.7995 6.03755C18.2379 6.07337 18.4621 6.1383 18.6185 6.21799L19.5265 4.43597C19.0411 4.18868 18.5244 4.09012 17.9623 4.04419C17.4119 3.99922 16.7341 4 15.9105 4V6ZM7.8 6H15.9105V4H7.8V6ZM5.09202 6.21799C5.24842 6.1383 5.47262 6.07337 5.91104 6.03755C6.36113 6.00078 6.94342 6 7.8 6V4C6.97642 4 6.2986 3.99922 5.74817 4.04419C5.18608 4.09012 4.66937 4.18868 4.18404 4.43597L5.09202 6.21799ZM4.21799 7.09202C4.40973 6.71569 4.71569 6.40973 5.09202 6.21799L4.18404 4.43597C3.43139 4.81947 2.81947 5.43139 2.43597 6.18404L4.21799 7.09202ZM8.42762 18.283C8.42762 18.8364 7.97881 19.2829 7.42777 19.2829V17.2829C6.87657 17.2829 6.42762 17.7295 6.42762 18.283H8.42762ZM8.13469 18.9902C8.32221 18.8027 8.42762 18.5483 8.42762 18.283H6.42762C6.42762 18.0178 6.53301 17.7635 6.72048 17.576L8.13469 18.9902Z"
				fill={strokeColor}
			/>
			<path
				d="M7.42773 9.42773L16.283 9.42773"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.42773 13.8545L12.9623 13.8545"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function PaperClipIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || SemanticColor.INFO_MEDIUM;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.1111 8.11111V14.3333C10.1111 15.1924 10.8076 15.8889 11.6667 15.8889V15.8889C12.5258 15.8889 13.2222 15.1924 13.2222 14.3333V8.11111C13.2222 6.39289 11.8293 5 10.1111 5V5C8.39289 5 7 6.39289 7 8.11111V14.3333C7 16.9107 9.08934 19 11.6667 19V19C14.244 19 16.3333 16.9107 16.3333 14.3333V10.4444"
				stroke={strokeColor}
				strokeWidth="1.2"
				strokeLinecap="round"
			/>
		</svg>
	);
}

function MoveIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || NeutralColor.NEUTRAL_GREY_900;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M11.3892 7.5L14.167 10M14.167 10L11.3892 12.5M14.167 10H5.83366"
				stroke={strokeColor}
				strokeLinecap="round"
			/>
			<rect
				x="2.16699"
				y="2.16602"
				width="15.6667"
				height="15.6667"
				rx="3.5"
				stroke={strokeColor}
			/>
		</svg>
	);
}

function WorldIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || "white";
	const fillColor = props.fillColor || NeutralColor.NEUTRAL_GREY_900;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<mask id="path-1-inside-1_2382_3438" fill={strokeColor}>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M22 12C22 15.4596 20.2432 18.5089 17.573 20.3044L17.8478 19.4533C18.0265 18.8998 18.148 18.3293 18.2102 17.751L18.3435 16.5131C18.5746 14.3663 17.7245 12.2448 16.0749 10.8516L13.4136 8.60397C12.9462 8.20921 12.8058 7.54786 13.0725 6.99725C13.2963 6.53532 13.7644 6.24194 14.2776 6.24194H18.0663C18.6203 6.24194 19.1586 6.0579 19.5967 5.71874L19.7099 5.63111C21.1404 7.36086 22 9.58004 22 12ZM12 22C13.5335 22 14.9864 21.6548 16.2853 21.0379L16.8962 19.146C17.0539 18.6576 17.1611 18.1543 17.216 17.644L17.3492 16.4061C17.5448 14.5895 16.8255 12.7944 15.4296 11.6156L12.7684 9.36795C11.9519 8.67838 11.7067 7.52313 12.1725 6.56132C12.5634 5.75442 13.3811 5.24194 14.2776 5.24194H18.0663C18.3987 5.24194 18.7217 5.13152 18.9845 4.92802L19.0327 4.89075C17.2262 3.10356 14.742 2 12 2C6.93738 2 2.75343 5.76207 2.09128 10.6431L5.82132 9.99034C7.51142 9.69457 8.99034 11.1503 8.72137 12.8448L8.48362 14.3426C8.25769 15.766 8.9645 17.175 10.2405 17.8449C11.6147 18.5664 12.3248 20.1278 11.9653 21.6377L11.8792 21.9993C11.9194 21.9998 11.9597 22 12 22ZM10.8662 21.9364C5.8772 21.3734 2 17.1395 2 12C2 11.7658 2.00805 11.5334 2.0239 11.3032L2.08619 11.6592L5.9937 10.9754C7.00776 10.7979 7.89512 11.6713 7.73373 12.6881L7.49599 14.1858C7.20282 16.0328 8.11996 17.861 9.77571 18.7303C10.7452 19.2393 11.2461 20.3408 10.9925 21.406L10.8662 21.9364Z"
				/>
			</mask>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 12C22 15.4596 20.2432 18.5089 17.573 20.3044L17.8478 19.4533C18.0265 18.8998 18.148 18.3293 18.2102 17.751L18.3435 16.5131C18.5746 14.3663 17.7245 12.2448 16.0749 10.8516L13.4136 8.60397C12.9462 8.20921 12.8058 7.54786 13.0725 6.99725C13.2963 6.53532 13.7644 6.24194 14.2776 6.24194H18.0663C18.6203 6.24194 19.1586 6.0579 19.5967 5.71874L19.7099 5.63111C21.1404 7.36086 22 9.58004 22 12ZM12 22C13.5335 22 14.9864 21.6548 16.2853 21.0379L16.8962 19.146C17.0539 18.6576 17.1611 18.1543 17.216 17.644L17.3492 16.4061C17.5448 14.5895 16.8255 12.7944 15.4296 11.6156L12.7684 9.36795C11.9519 8.67838 11.7067 7.52313 12.1725 6.56132C12.5634 5.75442 13.3811 5.24194 14.2776 5.24194H18.0663C18.3987 5.24194 18.7217 5.13152 18.9845 4.92802L19.0327 4.89075C17.2262 3.10356 14.742 2 12 2C6.93738 2 2.75343 5.76207 2.09128 10.6431L5.82132 9.99034C7.51142 9.69457 8.99034 11.1503 8.72137 12.8448L8.48362 14.3426C8.25769 15.766 8.9645 17.175 10.2405 17.8449C11.6147 18.5664 12.3248 20.1278 11.9653 21.6377L11.8792 21.9993C11.9194 21.9998 11.9597 22 12 22ZM10.8662 21.9364C5.8772 21.3734 2 17.1395 2 12C2 11.7658 2.00805 11.5334 2.0239 11.3032L2.08619 11.6592L5.9937 10.9754C7.00776 10.7979 7.89512 11.6713 7.73373 12.6881L7.49599 14.1858C7.20282 16.0328 8.11996 17.861 9.77571 18.7303C10.7452 19.2393 11.2461 20.3408 10.9925 21.406L10.8662 21.9364Z"
				fill={fillColor}
			/>
			<path
				d="M17.573 20.3044L15.6697 19.6898L13.8942 25.1881L18.689 21.9641L17.573 20.3044ZM17.8478 19.4533L15.9446 18.8387L15.9446 18.8387L17.8478 19.4533ZM18.2102 17.751L20.1988 17.965V17.965L18.2102 17.751ZM18.3435 16.5131L16.355 16.2991V16.2991L18.3435 16.5131ZM16.0749 10.8516L17.3654 9.32363L16.0749 10.8516ZM13.4136 8.60397L12.1232 10.1319H12.1232L13.4136 8.60397ZM13.0725 6.99725L14.8725 7.8691V7.8691L13.0725 6.99725ZM19.5967 5.71874L18.3724 4.13729L18.3724 4.1373L19.5967 5.71874ZM19.7099 5.63111L21.2511 4.35651L20.0169 2.86411L18.4856 4.04966L19.7099 5.63111ZM16.2853 21.0379L17.1434 22.8444L17.9232 22.474L18.1885 21.6525L16.2853 21.0379ZM16.8962 19.146L18.7994 19.7606V19.7606L16.8962 19.146ZM17.216 17.644L19.2045 17.858L17.216 17.644ZM17.3492 16.4061L19.3377 16.6201L17.3492 16.4061ZM15.4296 11.6156L14.1392 13.1435L15.4296 11.6156ZM12.7684 9.36795L11.4779 10.8959L12.7684 9.36795ZM12.1725 6.56132L10.3726 5.68946L10.3726 5.68946L12.1725 6.56132ZM18.9845 4.92802L17.7602 3.34657L17.7602 3.34657L18.9845 4.92802ZM19.0327 4.89075L20.257 6.47221L22.0623 5.0746L20.4393 3.46895L19.0327 4.89075ZM2.09128 10.6431L0.109437 10.3742L-0.258254 13.0847L2.43604 12.6132L2.09128 10.6431ZM5.82132 9.99034L6.16608 11.9604L5.82132 9.99034ZM8.72137 12.8448L6.74609 12.5313V12.5313L8.72137 12.8448ZM8.48362 14.3426L6.50835 14.0291L8.48362 14.3426ZM10.2405 17.8449L11.1702 16.0741H11.1702L10.2405 17.8449ZM11.9653 21.6377L13.9109 22.1009L11.9653 21.6377ZM11.8792 21.9993L9.93361 21.536L9.3542 23.9696L11.8556 23.9991L11.8792 21.9993ZM10.8662 21.9364L10.642 23.9238L12.4017 24.1224L12.8118 22.3997L10.8662 21.9364ZM2.0239 11.3032L3.99396 10.9585L0.0286173 11.1659L2.0239 11.3032ZM2.08619 11.6592L0.116129 12.0039L0.46089 13.974L2.43095 13.6292L2.08619 11.6592ZM5.9937 10.9754L5.64894 9.00531H5.64894L5.9937 10.9754ZM7.73373 12.6881L5.75846 12.3745V12.3745L7.73373 12.6881ZM7.49599 14.1858L9.47126 14.4994L7.49599 14.1858ZM9.77571 18.7303L8.84604 20.5011H8.84604L9.77571 18.7303ZM10.9925 21.406L12.9381 21.8693L10.9925 21.406ZM18.689 21.9641C21.8882 19.8129 24 16.1534 24 12H20C20 14.7658 18.5982 17.2049 16.457 18.6447L18.689 21.9641ZM15.9446 18.8387L15.6697 19.6898L19.4762 20.919L19.751 20.0679L15.9446 18.8387ZM16.2217 17.537C16.1741 17.9792 16.0813 18.4154 15.9446 18.8387L19.751 20.0679C19.9718 19.3841 20.1219 18.6795 20.1988 17.965L16.2217 17.537ZM16.355 16.2991L16.2217 17.537L20.1988 17.965L20.332 16.7271L16.355 16.2991ZM14.7844 12.3795C15.9264 13.3441 16.515 14.8128 16.355 16.2991L20.332 16.7271C20.6342 13.9197 19.5225 11.1455 17.3654 9.32363L14.7844 12.3795ZM12.1232 10.1319L14.7844 12.3795L17.3654 9.32363L14.7041 7.07601L12.1232 10.1319ZM11.2726 6.12539C10.6075 7.4984 10.9576 9.14756 12.1232 10.1319L14.7041 7.07601C14.9348 7.27086 15.0041 7.59732 14.8725 7.8691L11.2726 6.12539ZM14.2776 4.24194C12.9978 4.24194 11.8305 4.97352 11.2726 6.12539L14.8725 7.8691C14.762 8.09712 14.531 8.24194 14.2776 8.24194V4.24194ZM18.0663 4.24194H14.2776V8.24194H18.0663V4.24194ZM18.3724 4.1373C18.2848 4.20513 18.1771 4.24194 18.0663 4.24194V8.24194C19.0635 8.24194 20.0325 7.91068 20.8211 7.30019L18.3724 4.1373ZM18.4856 4.04966L18.3724 4.13729L20.8211 7.3002L20.9343 7.21256L18.4856 4.04966ZM24 12C24 9.09782 22.9672 6.43156 21.2511 4.35651L18.1687 6.90571C19.3136 8.29016 20 10.0623 20 12H24ZM15.4272 19.2313C14.3908 19.7236 13.2305 20 12 20V24C13.8366 24 15.5821 23.586 17.1434 22.8444L15.4272 19.2313ZM14.9929 18.5314L14.382 20.4233L18.1885 21.6525L18.7994 19.7606L14.9929 18.5314ZM15.2275 17.4299C15.1872 17.8042 15.1086 18.1733 14.9929 18.5314L18.7994 19.7606C18.9992 19.1419 19.1349 18.5044 19.2045 17.858L15.2275 17.4299ZM15.3607 16.192L15.2275 17.4299L19.2045 17.858L19.3377 16.6201L15.3607 16.192ZM14.1392 13.1435C15.0274 13.8937 15.4852 15.036 15.3607 16.192L19.3377 16.6201C19.6044 14.143 18.6235 11.6952 16.7201 10.0876L14.1392 13.1435ZM11.4779 10.8959L14.1392 13.1435L16.7201 10.0876L14.0589 7.83999L11.4779 10.8959ZM10.3726 5.68946C9.50836 7.47367 9.96333 9.61673 11.4779 10.8959L14.0589 7.83999C13.9405 7.74004 13.905 7.57259 13.9725 7.43318L10.3726 5.68946ZM14.2776 3.24194C12.6144 3.24194 11.0976 4.19263 10.3726 5.68946L13.9725 7.43318C14.0292 7.31622 14.1477 7.24194 14.2776 7.24194V3.24194ZM18.0663 3.24194H14.2776V7.24194H18.0663V3.24194ZM17.7602 3.34657C17.8478 3.27874 17.9555 3.24194 18.0663 3.24194V7.24194C18.8419 7.24194 19.5956 6.98429 20.2089 6.50947L17.7602 3.34657ZM17.8083 3.3093L17.7602 3.34657L20.2089 6.50948L20.257 6.47221L17.8083 3.3093ZM12 4C14.1942 4 16.1788 4.88071 17.6261 6.31255L20.4393 3.46895C18.2735 1.32641 15.2897 0 12 0V4ZM4.07313 10.9119C4.60259 7.00908 7.95154 4 12 4V0C5.92322 0 0.904282 4.51506 0.109437 10.3742L4.07313 10.9119ZM2.43604 12.6132L6.16608 11.9604L5.47656 8.02028L1.74652 8.67303L2.43604 12.6132ZM6.16608 11.9604C6.50411 11.9012 6.79989 12.1924 6.74609 12.5313L10.6966 13.1584C11.1808 10.1081 8.51873 7.4879 5.47656 8.02028L6.16608 11.9604ZM6.74609 12.5313L6.50835 14.0291L10.4589 14.6561L10.6966 13.1584L6.74609 12.5313ZM6.50835 14.0291C6.14796 16.2996 7.27542 18.5471 9.31087 19.6157L11.1702 16.0741C10.6536 15.8029 10.3674 15.2324 10.4589 14.6561L6.50835 14.0291ZM9.31087 19.6157C9.87564 19.9122 10.1675 20.5539 10.0197 21.1744L13.9109 22.1009C14.4822 19.7017 13.3539 17.2205 11.1702 16.0741L9.31087 19.6157ZM10.0197 21.1744L9.93361 21.536L13.8248 22.4625L13.9109 22.1009L10.0197 21.1744ZM12 20C11.9676 20 11.9353 19.9998 11.9029 19.9994L11.8556 23.9991C11.9036 23.9997 11.9517 24 12 24V20ZM11.0905 19.9491C7.10139 19.4989 4 16.1102 4 12H0C0 18.1688 4.65301 23.248 10.642 23.9238L11.0905 19.9491ZM4 12C4 11.8116 4.00648 11.6251 4.01918 11.4405L0.0286173 11.1659C0.00962996 11.4418 0 11.7199 0 12H4ZM4.05625 11.3144L3.99396 10.9585L0.0538361 11.648L0.116129 12.0039L4.05625 11.3144ZM5.64894 9.00531L1.74143 9.68912L2.43095 13.6292L6.33847 12.9454L5.64894 9.00531ZM9.709 13.0016C10.0856 10.6292 8.01507 8.59123 5.64894 9.00531L6.33846 12.9454C6.00045 13.0046 5.70466 12.7134 5.75846 12.3745L9.709 13.0016ZM9.47126 14.4994L9.709 13.0016L5.75846 12.3745L5.52072 13.8723L9.47126 14.4994ZM10.7054 16.9595C9.80904 16.4889 9.31255 15.4992 9.47126 14.4994L5.52072 13.8723C5.09309 16.5664 6.43087 19.2331 8.84604 20.5011L10.7054 16.9595ZM12.9381 21.8693C13.4035 19.9147 12.4843 17.8934 10.7054 16.9595L8.84604 20.5011C9.00608 20.5851 9.08878 20.767 9.04691 20.9428L12.9381 21.8693ZM12.8118 22.3997L12.9381 21.8693L9.04691 20.9428L8.92062 21.4732L12.8118 22.3997Z"
				fill={fillColor}
				mask="url(#path-1-inside-1_2382_3438)"
			/>
		</svg>
	);
}

function AddressIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || "white";
	const fillColor = props.fillColor || NeutralColor.NEUTRAL_GREY_900;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.4756 19.6393C13.9962 18.8532 19.3559 15.7111 19.3559 10.4773C19.3559 6.45772 16.0974 3.19922 12.0779 3.19922C8.0583 3.19922 4.7998 6.45772 4.7998 10.4773C4.7998 15.7111 10.1595 18.8532 11.6801 19.6393C11.9331 19.7701 12.2226 19.7701 12.4756 19.6393ZM12.0779 13.5964C13.8006 13.5964 15.1971 12.1999 15.1971 10.4773C15.1971 8.7546 13.8006 7.3581 12.0779 7.3581C10.3553 7.3581 8.95876 8.7546 8.95876 10.4773C8.95876 12.1999 10.3553 13.5964 12.0779 13.5964Z"
				fill={fillColor}
			/>
		</svg>
	);
}

function WebsiteIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 20;
	const strokeColor = props.strokeColor || "white";
	const fillColor = props.fillColor || NeutralColor.NEUTRAL_GREY_900;
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.78582 6.5724C9.28377 7.87774 8.9436 9.6525 8.87424 11.6484L14.3898 11.6484C14.3204 9.6525 13.9802 7.87774 13.4782 6.5724C13.1951 5.83653 12.8704 5.27533 12.5352 4.90677C12.2002 4.53835 11.8943 4.40208 11.632 4.40208C11.3697 4.40208 11.0638 4.53835 10.7288 4.90677C10.3936 5.27533 10.0689 5.83653 9.78582 6.5724ZM3.03023 11.6484H7.87367C7.94329 9.55248 8.29941 7.65141 8.85248 6.21342C9.16136 5.41033 9.54141 4.72611 9.98891 4.234C10.064 4.15141 10.1421 4.07311 10.2231 4C6.37854 4.57932 3.37726 7.73244 3.03023 11.6484ZM3 12.6484C3.11496 16.8053 6.21297 20.2168 10.23 20.8188C10.1465 20.7439 10.0661 20.6635 9.98891 20.5786C9.54141 20.0865 9.16136 19.4023 8.85248 18.5992C8.25436 17.0441 7.8866 14.9474 7.86241 12.6484H3ZM13.0932 20.7643C16.953 20.0332 19.89 16.6938 20.0018 12.6484L15.4016 12.6484C15.3774 14.9474 15.0096 17.0441 14.4115 18.5992C14.1026 19.4023 13.7226 20.0865 13.2751 20.5786C13.2163 20.6433 13.1556 20.7053 13.0932 20.7643ZM19.9716 11.6484C19.6343 7.8422 16.7895 4.75668 13.1 4.05474C13.16 4.11179 13.2184 4.17167 13.2751 4.234C13.7226 4.72611 14.1026 5.41033 14.4115 6.21342C14.9646 7.65141 15.3207 9.55248 15.3903 11.6484L19.9716 11.6484ZM13.4782 18.2402C14.0231 16.8235 14.3773 14.8537 14.4015 12.6484H8.86247C8.88671 14.8537 9.24091 16.8235 9.78582 18.2402C10.0689 18.9761 10.3936 19.5373 10.7288 19.9059C11.0638 20.2743 11.3697 20.4105 11.632 20.4105C11.8943 20.4105 12.2002 20.2743 12.5352 19.9059C12.8704 19.5373 13.1951 18.9761 13.4782 18.2402Z"
				fill={fillColor}
			/>
		</svg>
	);
}

function SearchIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	const fillColor = props.fillColor || "white";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.9382 7.66945C18.512 4.24481 15.1704 2.01016 11.4607 
				2.00025C7.46246 1.9792 3.90737 4.54018 2.66105 8.33922C1.41473 
				12.1383 2.7619 16.3075 5.99559 18.6589C9.22927 21.0104 13.6107 
				21.0069 16.8407 18.6503L19.7207 21.5303C20.0135 21.8227 
				20.4878 21.8227 20.7807 21.5303C21.0731 21.2374 21.0731 20.7631 
				20.7807 20.4703L17.9907 17.6803C20.5968 15.0401 21.3644 11.0941 
				19.9382 7.66945ZM18.6011 14.1692C17.4036 17.0549 14.5849 18.9343 
				11.4607 18.9303V18.8903C7.22037 18.8848 3.77812 15.4605 3.75066 
				11.2203C3.74662 8.09599 5.62605 5.27729 8.51172 4.07982C11.3974 2.88235 14.7203 3.5422 16.9295 5.75139C19.1387 
				7.96058 19.7986 11.2835 18.6011 14.1692Z"
				fill={strokeColor}
			/>
		</svg>
	);
}

function RightArrowIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	const fillColor = props.fillColor || "white";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M20.05 11.47L13.05 4.47C12.8571 4.28243 12.5787 4.21204 12.3198 4.28533C12.0609 4.35863 
					11.8608 4.56447 11.7948 4.82533C11.7289 5.08619 11.8071 5.36243 12 5.55L17.71 11.25H4.47998C4.06577 
					11.25 3.72998 11.5858 3.72998 12C3.72998 12.4142 4.06577 12.75 4.47998 12.75H17.7L12 18.45C11.857 
					18.5893 11.7764 18.7804 11.7764 18.98C11.7764 19.1796 11.857 19.3707 12 19.51C12.1378 19.6546 12.3302 
					19.7345 12.53 19.73C12.729 19.7309 12.9201 19.6516 13.06 19.51L20.06 12.51C20.3524 12.2172 20.3524 11.7428 20.06 11.45L20.05 11.47Z"
				fill={strokeColor}
			/>
		</svg>
	);
}
function AddClientIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	const fillColor = props.fillColor || "white";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M1.6499 21.9333C1.64986 22.3475 1.9856 22.6833 2.39982 22.6834C2.81403 22.6834 3.14986 22.3477 3.1499 21.9335L1.6499 21.9333ZM2.40031 18.333L3.15031 18.3331L2.40031 18.333ZM12.5999 15.4834C13.0141 15.4834 13.3499 15.1476 13.3499 14.7334C13.3499 14.3192 13.0141 13.9834 12.5999 13.9834V15.4834ZM21.5999 16.6834C22.0141 16.6834 22.3499 16.3476 22.3499 15.9334C22.3499 15.5192 22.0141 15.1834 21.5999 15.1834V16.6834ZM16.1999 15.1834C15.7857 15.1834 15.4499 15.5192 15.4499 15.9334C15.4499 16.3476 15.7857 16.6834 16.1999 16.6834V15.1834ZM18.1499 18.6333C18.1499 19.0475 18.4857 19.3833 18.8999 19.3833C19.3141 19.3833 19.6499 19.0475 19.6499 18.6333H18.1499ZM19.6499 13.2333C19.6499 12.819 19.3141 12.4833 18.8999 12.4833C18.4857 12.4833 18.1499 12.819 18.1499 13.2333H19.6499ZM13.6499 6.3334C13.6499 7.90741 12.3739 9.1834 10.7999 9.1834V10.6834C13.2023 10.6834 15.1499 8.73584 15.1499 6.3334H13.6499ZM10.7999 9.1834C9.22589 9.1834 7.9499 7.90741 7.9499 6.3334H6.4499C6.4499 8.73584 8.39746 10.6834 10.7999 10.6834V9.1834ZM7.9499 6.3334C7.9499 4.75939 9.22589 3.4834 10.7999 3.4834V1.9834C8.39746 1.9834 6.4499 3.93096 6.4499 6.3334H7.9499ZM10.7999 3.4834C12.3739 3.4834 13.6499 4.75939 13.6499 6.3334H15.1499C15.1499 3.93096 13.2023 1.9834 10.7999 1.9834V3.4834ZM3.1499 21.9335L3.15031 18.3331L1.65031 18.3329L1.6499 21.9333L3.1499 21.9335ZM6.00031 13.9834C3.59806 13.9834 1.65058 15.9307 1.65031 18.3329L3.15031 18.3331C3.15048 16.7592 4.42642 15.4834 6.00031 15.4834V13.9834ZM6.00031 15.4834H12.5999V13.9834H6.00031V15.4834ZM21.5999 15.1834H18.8999V16.6834H21.5999V15.1834ZM18.8999 15.1834H16.1999V16.6834H18.8999V15.1834ZM19.6499 18.6333V15.9334H18.1499V18.6333H19.6499ZM19.6499 15.9334V13.2333H18.1499V15.9334H19.6499Z"
				fill={fillColor}
			/>
		</svg>
	);
}
function AddItemBagIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	const fillColor = props.fillColor || "white";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M21.6005 6.63353L2.40115 6.63326L2.3999 6.63359M21.6005 6.63353L21.5999 19.9496C21.5999 21.211 20.5579 22.2336 19.2726 22.2336H4.72718C3.44186 22.2336 2.3999 21.211 2.3999 19.9496V6.63359M21.6005 6.63353L17.7514 2.78507C17.5263 2.56002 17.2211 2.43359 16.9028 2.43359H7.09696C6.7787 2.43359 6.47347 2.56002 6.24843 2.78507L2.3999 6.63359M15.5999 10.2336C15.5999 12.2218 13.9881 13.8336 11.9999 13.8336C10.0117 13.8336 8.3999 12.2218 8.3999 10.2336"
				stroke={strokeColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
function ReviewOrderEyeIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	const fillColor = props.fillColor || "white";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.75 12.3335C13.1642 12.3335 13.5 11.9977 13.5 11.5835C13.5 11.1693 13.1642 10.8335 12.75 10.8335C12.3358 10.8335 12 11.1693 12 11.5835C12 11.9977 12.3358 12.3335 12.75 12.3335Z"
				stroke={strokeColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 16.8335C14.4853 16.8335 16.5 14.8188 16.5 12.3335C16.5 9.84821 14.4853 7.8335 12 7.8335C9.51472 7.8335 7.5 9.84821 7.5 12.3335C7.5 14.8188 9.51472 16.8335 12 16.8335Z"
				stroke={strokeColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1.5 12.3335C1.5 12.3335 5.25 4.8335 12 4.8335C18.75 4.8335 22.5 12.3335 22.5 12.3335C22.5 12.3335 18.75 19.8335 12 19.8335C5.25 19.8335 1.5 12.3335 1.5 12.3335Z"
				stroke={strokeColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
function CardIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	const fillColor = props.fillColor || "#121212";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M19.1995 5.1001H4.7999C3.47439 5.1001 2.39986 6.17465 2.3999 7.50016L2.40016 16.5C2.4002 17.8254 3.47469 18.8999 4.80014 18.8999L19.1998 18.9001C20.5253 18.9001 21.5998 17.8266 21.5998 16.5011L21.5995 7.49923C21.5995 6.17377 20.525 5.1001 19.1995 5.1001Z"
				fill={fillColor}
			/>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M2.99944 9.29995H20.9994M6.59944 13.4999H9.59944M4.7999 5.1001H19.1995C20.525 5.1001 21.5995 6.17377 21.5995 7.49923L21.5998 16.5011C21.5998 17.8266 20.5253 18.9001 19.1998 18.9001L4.80014 18.8999C3.47469 18.8999 2.4002 17.8254 2.40016 16.5L2.3999 7.50016C2.39986 6.17465 3.47439 5.1001 4.7999 5.1001Z"
				stroke="#121212"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M6.5 13.5H9.5"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M2 9L22 9"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="square"
			/>
		</svg>
	);
}
function TruckIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	const fillColor = props.fillColor || "#121212";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				xmlns="http://www.w3.org/2000/svg"
				x="3"
				y="5"
				width="11"
				height="12"
				fill={fillColor}
			/>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M10.6285 16.5711C10.6285 17.8335 9.60512 18.8569 8.34276 18.8569C7.08039 18.8569 6.05704 17.8335 6.05704 16.5711C6.05704 15.3088 7.08039 14.2854 8.34276 14.2854C9.60512 14.2854 10.6285 15.3088 10.6285 16.5711Z"
				fill="white"
			/>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M20.2285 16.5711C20.2285 17.8335 19.2051 18.8569 17.9428 18.8569C16.6804 18.8569 15.657 17.8335 15.657 16.5711C15.657 15.3088 16.6804 14.2854 17.9428 14.2854C19.2051 14.2854 20.2285 15.3088 20.2285 16.5711Z"
				fill="white"
			/>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M5.14276 17.0283H4.22847C3.21858 17.0283 2.3999 16.2096 2.3999 15.1997V6.97115C2.3999 5.96126 3.21858 5.14258 4.22847 5.14258H12.457C13.4669 5.14258 14.2856 5.96126 14.2856 6.97115V15.1997C14.2856 16.2096 13.4669 17.0283 12.457 17.0283H11.5428M15.657 17.0283H15.1999C14.695 17.0283 14.2856 16.619 14.2856 16.114V8.34258C14.2856 7.83763 14.695 7.42829 15.1999 7.42829H17.5033C17.7811 7.42829 18.0438 7.55455 18.2173 7.77143L21.3995 11.7493C21.5292 11.9114 21.5999 12.1128 21.5999 12.3204V16.114C21.5999 16.619 21.1906 17.0283 20.6856 17.0283M10.6285 16.5711C10.6285 17.8335 9.60512 18.8569 8.34276 18.8569C7.08039 18.8569 6.05704 17.8335 6.05704 16.5711C6.05704 15.3088 7.08039 14.2854 8.34276 14.2854C9.60512 14.2854 10.6285 15.3088 10.6285 16.5711ZM20.2285 16.5711C20.2285 17.8335 19.2051 18.8569 17.9428 18.8569C16.6804 18.8569 15.657 17.8335 15.657 16.5711C15.657 15.3088 16.6804 14.2854 17.9428 14.2854C19.2051 14.2854 20.2285 15.3088 20.2285 16.5711Z"
				stroke={fillColor}
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
}

function BackIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	const fillColor = props.fillColor || "#121212";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M14 7L9.42 12.0008L14 17"
				stroke={fillColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function AddIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	const fillColor = props.fillColor || "white";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M12 6L12 18"
				stroke={fillColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M18 12L6 12"
				stroke={fillColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function InstrumentInfoIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || PrimaryColor.PRIMARY_800;
	const fillColor = props.fillColor || "black";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.75 3.37496H10.875C11.0821 3.37496 11.25 3.54284 11.25 3.74996V10.875C11.25 11.0821 11.0821 11.25 10.875 11.25H3.75C3.54288 11.25 3.375 11.0821 3.375 10.875V3.74996C3.375 3.54284 3.54288 3.37496 3.75 3.37496ZM16.9761 2.78121L21.2187 7.02387C21.3652 7.17031 21.3652 7.40773 21.2187 7.55419L16.9761 11.7968C16.8296 11.9433 16.5922 11.9433 16.4458 11.7968L12.2031 7.55417C12.0567 7.40773 12.0567 7.17031 12.2031 7.02385L16.4458 2.78121C16.5922 2.63478 16.8296 2.63478 16.9761 2.78121ZM3.75 12.75H10.875C11.0821 12.75 11.25 12.9178 11.25 13.125V20.25C11.25 20.4571 11.0821 20.625 10.875 20.625H3.75C3.54288 20.625 3.375 20.4571 3.375 20.25V13.125C3.375 12.9178 3.54288 12.75 3.75 12.75ZM13.125 12.75H20.25C20.4571 12.75 20.625 12.9178 20.625 13.125V20.25C20.625 20.4571 20.4571 20.625 20.25 20.625H13.125C12.9179 20.625 12.75 20.4571 12.75 20.25V13.125C12.75 12.9178 12.9179 12.75 13.125 12.75Z"
				fill={fillColor}
			/>
		</svg>
	);
}

function WrenchIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 24;
	const strokeColor = props.strokeColor || "#121212";
	const fillColor = props.fillColor || "#121212";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M20.9811 7.37503C20.9672 7.2148 20.6096 6.90708 20.4582 6.85219C20.3065 6.79697 20.1367 6.83456 20.0225 6.94809L17.7329 9.23769L14.759 6.26374L17.0944 3.93712C17.2087 3.82337 17.246 3.65413 17.1909 3.50324C17.1353 3.35205 16.7686 3.03175 16.6074 3.01787C15.1891 2.89613 13.7994 3.40061 12.7946 4.40174C11.4185 5.77278 11.0541 7.77488 11.6994 9.48143C11.6289 9.54063 11.5593 9.60335 11.4906 9.671L3.69505 16.9993C3.6923 17.002 3.68959 17.0049 3.68662 17.0075C2.76983 17.9209 2.76983 19.407 3.68662 20.3206C4.60356 21.2339 6.08439 21.2228 7.00103 20.3094C7.00499 20.3057 7.0086 20.302 7.01222 20.2979L14.3041 12.4712C14.3705 12.4047 14.4322 12.3351 14.4904 12.2637C16.2039 12.9077 18.2148 12.5455 19.5921 11.1736C20.5967 10.1724 21.1034 8.78782 20.9811 7.37503Z"
				fill={strokeColor}
				stroke={fillColor}
				strokeWidth="2"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function TickIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 16;
	const strokeColor = props.strokeColor || "#121212";
	const fillColor = props.fillColor || "#3496FE";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M2.85352 8.75L6.19004 12.25L12.8631 4.75"
				stroke={fillColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function ReceiptIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 48;
	const strokeColor = props.strokeColor || "#062E3E";
	const fillColor = props.fillColor || "#BAD9E7";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 48 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M36.4428 6.01849H11.5084C9.78704 6.01849 8.3916 7.62861 8.3916 9.61479V41.9815L13.5863 38.3852L18.7809 41.9815L23.9756 38.3852L29.1702 41.9815L34.3649 38.3852L39.5595 41.9815V9.6148C39.5595 7.62861 38.1641 6.01849 36.4428 6.01849Z"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M15 23.0247C15 18.0541 19.0294 14.0247 24 14.0247C28.9706 14.0247 33 18.0541 33 23.0247C33 27.9952 28.9706 32.0247 24 32.0247C19.0294 32.0247 15 27.9952 15 23.0247Z"
				fill={fillColor}
			/>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M27.142 21.0077L22.875 25.2747L21.4205 23.8202M24 14.0247C19.0294 14.0247 15 18.0541 15 23.0247C15 27.9952 19.0294 32.0247 24 32.0247C28.9706 32.0247 33 27.9952 33 23.0247C33 18.0541 28.9706 14.0247 24 14.0247Z"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function WrenchCircleIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 48;
	const strokeColor = props.strokeColor || "#062E3E";
	const fillColor = props.fillColor || "#BAD9E7";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 48 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M39.8828 8.09084L38.6591 15.5247C35.7157 10.4433 30.2142 7.02466 23.9132 7.02466C16.769 7.02466 10.6526 11.4195 8.12729 17.6497M8.11811 39.9585L9.34184 32.5247C12.2853 37.606 17.7867 41.0247 24.0877 41.0247C31.232 41.0247 37.3483 36.6298 39.8736 30.3997"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M33.981 19.6427C33.9664 19.4736 33.5889 19.1488 33.4292 19.0909C33.269 19.0326 33.0897 19.0723 32.9692 19.1921L30.5524 21.6089L27.4133 18.4697L29.8784 16.0138C29.9991 15.8938 30.0384 15.7151 29.9803 15.5559C29.9216 15.3963 29.5346 15.0582 29.3644 15.0435C27.8673 14.915 26.4004 15.4475 25.3398 16.5043C23.8873 17.9515 23.5026 20.0648 24.1838 21.8662C24.1093 21.9287 24.0358 21.9949 23.9634 22.0663L15.7347 29.8017C15.7318 29.8045 15.7289 29.8076 15.7258 29.8104C14.7581 30.7745 14.7581 32.3432 15.7258 33.3075C16.6937 34.2715 18.2568 34.2598 19.2243 33.2957C19.2285 33.2918 19.2323 33.2879 19.2361 33.2836L26.9331 25.0221C27.0033 24.9518 27.0684 24.8784 27.1298 24.803C28.9385 25.4828 31.0611 25.1005 32.515 23.6524C33.5753 22.5955 34.1102 21.134 33.981 19.6427Z"
				fill={fillColor}
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function DeliveryIcon(props: IconProps): JSX.Element {
	const iconSize = props.size || 48;
	const strokeColor = props.strokeColor || "#062E3E";
	const fillColor = props.fillColor || "#BAD9E7";
	return (
		<svg
			width={iconSize}
			height={iconSize}
			viewBox="0 0 48 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M5.99414 11.0144C5.99414 10.4621 6.44186 10.0144 6.99414 10.0144H28.9695C29.5218 10.0144 29.9695 10.4621 29.9695 11.0144V31.9908C29.9695 32.543 29.5218 32.9908 28.9695 32.9908H19.516C19.1816 32.9908 18.8694 32.8237 18.6839 32.5455L16.2424 28.8831C16.0785 28.6373 15.8143 28.4765 15.5207 28.4439L12.1263 28.0668C11.7376 28.0236 11.3595 28.2109 11.1583 28.5462L8.78288 32.5053C8.60215 32.8065 8.27665 32.9908 7.92538 32.9908H6.99414C6.44186 32.9908 5.99414 32.543 5.99414 31.9908V11.0144Z"
				fill={fillColor}
			/>
			<path
				xmlns="http://www.w3.org/2000/svg"
				d="M18.3952 32.8999C18.3952 35.7087 16.1743 37.9856 13.4348 37.9856C10.6952 37.9856 8.47435 35.7087 8.47435 32.8999M18.3952 32.8999C18.3952 30.0912 16.1743 27.8143 13.4348 27.8143C10.6952 27.8143 8.47435 30.0912 8.47435 32.8999M18.3952 32.8999H29.5561M8.47435 32.8999H7.99414C6.88957 32.8999 5.99414 32.0045 5.99414 30.8999V12.0144C5.99414 10.9098 6.88957 10.0144 7.99414 10.0144H27.5561C28.6607 10.0144 29.5561 10.9098 29.5561 12.0144V32.8999M40.7171 32.8999C40.7171 35.7087 38.4962 37.9856 35.7566 37.9856C33.0171 37.9856 30.7962 35.7087 30.7962 32.8999M40.7171 32.8999C40.7171 30.0912 38.4962 27.8143 35.7566 27.8143C33.0171 27.8143 30.7962 30.0912 30.7962 32.8999M40.7171 32.8999H40.9572C41.5094 32.8999 41.9572 32.4522 41.9572 31.8999V23.5424C41.9572 23.0206 41.7532 22.5195 41.3889 22.146L36.3453 16.975C35.9689 16.5891 35.4526 16.3715 34.9136 16.3715H29.5561V32.8999M30.7962 32.8999H29.5561"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export {
	AlertIcon,
	EditIcon,
	SmallEditIcon,
	InfoIcon,
	SaveIcon,
	CopyIcon,
	DeleteIcon,
	SmallDeleteIcon,
	COAIcon,
	ReportsIcon,
	ViewResultIcon,
	SortArrowIcon,
	DownloadIcon,
	UserIcon,
	UserGroupIcon,
	CommentIcon,
	BillingIcon,
	HomeIcon,
	OrderIcon,
	CompanyIcon,
	LockIcon,
	InvoiceIcon,
	FileIcon,
	LicenseIcon,
	EmailIcon,
	PhoneIcon,
	FolderIcon,
	UploadIcon,
	PaperClipIcon,
	MoveIcon,
	WorldIcon,
	AddressIcon,
	WebsiteIcon,
	SearchIcon,
	RightArrowIcon,
	AddClientIcon,
	AddItemBagIcon,
	ReviewOrderEyeIcon,
	CardIcon,
	TruckIcon,
	BackIcon,
	AddIcon,
	InstrumentInfoIcon,
	WrenchIcon,
	TickIcon,
	ReceiptIcon,
	WrenchCircleIcon,
	DeliveryIcon,
};
